const initState = {}

const restaurantReducer = (state = initState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case 'ADD_FAVORITE_SUCCESS':
      //console.log('add favorite success');
      return state;
    case 'ADD_FAVORITE_ERROR':
      //console.log('remove favorite error');
      return state;
    case 'REMOVE_FAVORITE_SUCCESS':
      //console.log('remove favorite success');
      return state;
    case 'REMOVE_FAVORITE_ERROR':
      //console.log('remove favorite error');
      return state;
    case 'SORT_RESTAURANTS_SUCCESS':
      //console.log('sort restaurants success')
      return ({...state, newProjects:payload})
    case 'UPDATE_SORT_OPTIONS_SUCCESS':
      //console.log('update sort options success')
      return ({...state, sortOptions:payload})
    case 'UPDATE_SORT_VISIBLE_SUCCESS':
      //console.log('update sort visible success')
      return ({...state, sortVisible:payload})

    default:
      return state;
  }
};

export default restaurantReducer;